import AssessmentDisplay from './AssessmentDisplay';

export default AssessmentDisplay;
